<template lang="html">
  <div>
   
    <div class="container-scroller">
      <app-header />
      <div class="container-fluid page-body-wrapper">
        <app-sidebar />
        <div class="main-panel">
          <div class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
          <!-- content wrapper ends -->
          <app-footer />
        </div>
        <!-- main panel ends -->
        <loader />

        <!-- <DraggableDiv v-show="showDraggable">
            <template slot="header">
            <h2>
              <div>
                <i class="fa fa-arrows float-right m-t-5" aria-hidden="true"></i>
                Orders Collection
                
              </div>
              
            </h2>
            </template>
            <template slot="main" >
               <b-list-group>
                 <b-list-group-item class="d-flex justify-content-between align-items-center"  href="#some-link">For Shipping: <b-badge variant="success" pill>14</b-badge></b-list-group-item>
                 <b-list-group-item class="d-flex justify-content-between align-items-center"  href="#some-link">For Closeout: <b-badge variant="primary" pill>14</b-badge></b-list-group-item>
                 <b-list-group-item class="d-flex justify-content-between align-items-center"  href="#some-link">For Pickup: <b-badge variant="info" pill>14</b-badge></b-list-group-item>
                 <b-list-group-item class="d-flex justify-content-between align-items-center"  href="#some-link">For Reprint Label: <b-badge variant="danger" pill>14</b-badge></b-list-group-item>
                 <b-list-group-item class="d-flex justify-content-between align-items-center"  href="#some-link">For Shipp. record Delete: <b-badge variant="warning" pill>14</b-badge></b-list-group-item>
               </b-list-group>
            </template>
      </DraggableDiv> -->
        <NoteBase v-show="showNote" />
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script lang="js">
import AppHeader from '../components/partials/AppHeader';
import AppSidebar from '../components/partials/AppSidebar';
import AppFooter from '../components/partials/AppFooter';
import Loader from '../components/common/Loader';
const TopBarLoader = () => import(/* webpackChunkName: "top-bar-loader" */ '../components/common/top-bar-loader')
// import DraggableDiv from '../components/orders/draggable-div'
import NoteBase from '../views/notes/note-base';
import EventBus from '../EventBus';
export default{
  data(){
    return {
      showDraggable: true,
      showNote: false
    }
  },
  mounted: function(){
    EventBus.$on('toggle-orders-collection', () => {
       this.showDraggable = !this.showDraggable;
    });
    EventBus.$on("access-notes", () => {
       this.showNote = true;
    })
     EventBus.$on("note-closed", () => {
       this.showNote = false;
    })
  },
  components: {
    AppHeader,
    AppSidebar,
    AppFooter,
    Loader,
    // DraggableDiv,
    NoteBase,
    TopBarLoader
  },
  beforeDestroy(){
    EventBus.$off('toggle-orders-collection');
    EventBus.$off("access-notes");
    EventBus.$off("note-closed");
  }
}
</script>

<style lang="scss">
@import "../assets/scss/style";
.list-group a {
  font-size: 13px;
}

</style>
